import { createContext, useContext } from 'react';
import { useQueryClient } from 'react-query';
import { useMstInstanceCreator } from 'utils/mst/useMstInstanceCreator';
import { TIAnnotationStore, createAnnotationsStore } from 'modules/Annotations/store/annotationsStore';

// should follow predictions code pattern of accounting for null store
export const AnnotationsStoreCtx = createContext<TIAnnotationStore>(null as unknown as TIAnnotationStore);

export function useAnnotationsStore(): TIAnnotationStore {
  return useContext(AnnotationsStoreCtx);
}

export function useCreateAnnotationsStore(env: CF.MSTEnvironment): ReturnType<typeof createAnnotationsStore> {
  const queryClient = useQueryClient();
  const store = useMstInstanceCreator(createAnnotationsStore, [], () => [undefined, { queryClient, env }]);

  return store;
}
